import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { TableHead, ToggleButton, ToggleButtonGroup } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { useTheme } from '@mui/material/styles'
import styled from '@mui/material/styles/styled'
import { IUserLog } from 'bets.oddprovider.lib.common.ts/models'
import moment from 'moment'
import * as React from 'react'
import { useState } from 'react'
import { BsBraces } from "react-icons/bs"
import { VscTable } from "react-icons/vsc"
import { DEFAULTGAP } from '../../globals'
import { StyledTableCell, StyledTableRow, TableBaseComponent, TableComponentSetCurrPageProps, TableObjWrapperComponent } from 'fwork.react.apptemplate'
import { UserLogsTableLayoutContent } from './common'

export const DataRowContentComponent = (props: {
  obj: any,
  layout: UserLogsTableLayoutContent
}) => {
  return props.layout == UserLogsTableLayoutContent.json ?
    <pre style={{ padding: '8px 16px' }}>{JSON.stringify(props.obj, null, 4)}</pre> :
    <div style={{ padding: 5, display: 'flex', flexDirection: 'column' }}>
      <label style={{marginBottom: 5}}>{props.obj.description}</label>
      <TableObjWrapperComponent obj={props.obj.value} quoteStr={false} />
    </div>
}

const DataRowComponent = (props: {
  userLog: IUserLog
  hideUserColumn?: boolean,
  layout: UserLogsTableLayoutContent
}) => {
  const [open, setOpen] = useState<boolean>()

  const width = props.hideUserColumn ? '25%' : '20%'
  const isDarkTheme = useTheme().palette.mode === 'dark'
  const color = isDarkTheme ? 'rgba(81,81,81,1)' : 'rgba(224,224,224,1)'

  return <>
    <StyledTableRow odd>
      {!props.hideUserColumn ? <StyledTableCell style={{ width }} align='left'>
        {props.userLog.user?.name}
      </StyledTableCell> : <></>}
      <StyledTableCell style={{ width }} align='left'>
        {props.userLog.description}
      </StyledTableCell>
      <StyledTableCell style={{ width }} align='left'>
        {props.userLog.additional_description}
      </StyledTableCell>
      <StyledTableCell style={{ width }} align='left'>
        {props.userLog.user_log_group?.name}
      </StyledTableCell>
      <StyledTableCell style={{ width }} align='left'>
        {`${moment(props.userLog.date).format('DD/MM/YYYY HH:mm')} `}
      </StyledTableCell>
      <StyledTableCell style={{ width: 50 }} align='left'>
        {props.userLog?.logs?.length ? <UpDownComponent
          open={open}
          onClick={() => {
            setOpen(!open)
          }}
        /> : <></>}
      </StyledTableCell>
    </StyledTableRow>
    {open ? <>
      {props?.userLog?.logs.map((l, idx) => <StyledTableRow>
        <StyledTableCell style={{ padding: 0, background: 'rgba(200,200,200,.08)', borderBottom: idx + 1 == props?.userLog?.logs?.length ? `3px solid ${color}` : `1px solid ${color}` }} colSpan={!props.hideUserColumn ? 6 : 5}>
          <div style={{ maxHeight: 350, overflow: 'auto' }}>
            <DataRowContentComponent obj={l} layout={props.layout} />
          </div>
        </StyledTableCell>
      </StyledTableRow>)}
    </> : <></>}
  </>
}

const UpDownComponent = (props: {
  open?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined,
}) => {
  return <IconButton style={{ height: 46, width: 46, }} size={'small'}
    onClick={props.onClick}>
    {props.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
  </IconButton>
}

const StyledTableTitleCell = styled(StyledTableCell)(({ theme }) => ({
  fontWeight: 'bold',
  whiteSpace: 'nowrap'
}))

export interface UserLogsTableComponentProps {
  logs: IUserLog[] | undefined,
  onRefreshClick?: () => void
  hideUserColumn?: boolean,
  setCurrPageRef?: React.MutableRefObject<TableComponentSetCurrPageProps>
}

export const UserLogsTableHeaderComponent = (props: {
  hideUserColumn?: boolean | undefined
}) => {
  return <TableHead style={{
    background: 'rgba(200,200,200,.08)'
  }}>
    <StyledTableRow>
      {!props.hideUserColumn ? <StyledTableTitleCell align='left'>Usuário</StyledTableTitleCell> : <></>}
      <StyledTableTitleCell align='left'>Descrição</StyledTableTitleCell>
      <StyledTableTitleCell align='left'>Desc. adicional</StyledTableTitleCell>
      <StyledTableTitleCell align='left'>Classificação de log</StyledTableTitleCell>
      <StyledTableTitleCell align='left'>Data</StyledTableTitleCell>
      <StyledTableTitleCell align='left'></StyledTableTitleCell>
    </StyledTableRow>
  </TableHead >
}

export const UserLogsTableComponent = (props: UserLogsTableComponentProps) => {
  const [layout, setLayout] = useState<UserLogsTableLayoutContent>(UserLogsTableLayoutContent.table)

  return <>
    <div style={{ paddingInline: DEFAULTGAP, }}>
      <ToggleButtonGroup
        value={layout}
        exclusive
        // onChange={handleAlignment}
        onChange={(
          event: React.MouseEvent<HTMLElement>,
          newLayout: UserLogsTableLayoutContent,
        ) => {
          setLayout(newLayout);
        }}
        aria-label="text alignment"
      >
        <ToggleButton value={UserLogsTableLayoutContent.json} aria-label="left aligned">
          <BsBraces />
        </ToggleButton>
        <ToggleButton value={UserLogsTableLayoutContent.table} aria-label="centered">
          <VscTable />
        </ToggleButton>
      </ToggleButtonGroup>
    </div>

    <TableBaseComponent
      wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
      setCurrPageRef={props.setCurrPageRef}
      header={<UserLogsTableHeaderComponent hideUserColumn={props.hideUserColumn} />}
      bodyList={props.logs || []}
      bodyRowBuilder={(userLog: IUserLog) => {
        return <DataRowComponent hideUserColumn={props.hideUserColumn} userLog={userLog} layout={layout} />
      }}
    />
  </>
}
